import { Link, Switch, Route, useRouteMatch } from '@appmaker/core/routes';
import clsx from 'clsx';
import { useFormSchema } from '../store/formSchema';
import { isAdmin as checkIsAdmin } from '@appmaker/core/store/user';

const MenuItem = ({ item, routeName, pathname, itemRoute }) => {
	let { url } = useRouteMatch();
	const formSchema = useFormSchema();
	const { template = {} } = formSchema;
	const isAdmin = checkIsAdmin();
	let isActive = pathname === routeName || pathname.startsWith(routeName + '/');

	return (
		<>
			<Link
				key={item.name}
				to={routeName}
				className={clsx(
					isActive
						? 'text-gray-900 font-medium'
						: 'text-gray-400 hover:bg-gray-50 font-regular',
					'group px-2 py-2 text-sm rounded-md flex flex-col transition-all'
				)}
			>
				<div className="flex items-center">
					<item.icon
						className={clsx(
							isActive ? 'text-gray-900' : 'text-gray-500',
							'flex-shrink-0 h-5 w-5'
						)}
						aria-hidden="true"
					/>
					<span className="line-clamp-1 ml-2">{item.name}</span>
				</div>
			</Link>
			{pathname.match(routeName) && (
				<div className="text-xs flex flex-col gap-1 ml-6">
					{Object.keys(template).map((item) => {
						if ((template[item] && !template[item].___isAdminTab) || isAdmin) {
							return (
								<Link
									className={clsx(
										pathname === routeName + template[item].path
											? 'text-gray-900 font-medium'
											: 'text-gray-400 hover:bg-gray-50 font-regular',
										'group px-2 py-1 text-sm rounded-md flex flex-col transition-all'
									)}
									to={`${url}${itemRoute}${template[item].path}`}
								>
									{template[item].title}
								</Link>
							);
						}
						return null;
					})}
				</div>
			)}
		</>
	);
};

export default MenuItem;
